import "./styles.scss";

import HomeSection from "./HomeSection";
import AboutSection from "./AboutSection";
import ValuesSection from "./ValuesSection";
import FormationsSection from "./FormationsSection";
import ContactSection from "./ContactSection";

import BilansSection from "./BilansSection";
import CoachingSection from "./CoachingSection";
import GrowthSection from "./GrowthSection";
import Modal from "../../components/Modal";
import OptimizeModal from "../../components/OptimizeModal";
import { useEffect, useState } from "react";
import { TypeFormation } from "../../models/Formation";
import IndicateursPerformanceModal from "../../components/IndicateursPerformancesModal";

const HomePage = () => {
  const [isFinancementsModalOpen, setIsFinancementsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<TypeFormation>(
    TypeFormation.FormationCatalogue
  );
  const [modalFormationId, setModalFormationId] = useState<string>();
  const [
    isIndicateursPerformanceModalOpen,
    setIsIndicateursPerformanceModalOpen
  ] = useState(false);

  const openFinancementsModal = (type: TypeFormation) => {
    setModalType(type);
    setIsFinancementsModalOpen(true);
  };

  const openIndicateursPerformanceModal = (type: TypeFormation, formationId?: string) => {
    setModalType(type);
    setModalFormationId(formationId);
    setIsIndicateursPerformanceModalOpen(true);
  };

  useEffect(() => {
    if (isFinancementsModalOpen || isIndicateursPerformanceModalOpen) {
      // Disable scroll on body when modal is open
      document.body.style.overflow = "hidden";
    } else {
      // Restore scroll when modal closed
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isFinancementsModalOpen]);

  return (
    <div className="home">
      <HomeSection />
      <AboutSection />
      <GrowthSection />
      <ValuesSection />
      <FormationsSection
        openIndicateursPerformanceModal={openIndicateursPerformanceModal}
        openFinancementsModal={openFinancementsModal}
      />
      <BilansSection
        openIndicateursPerformanceModal={openIndicateursPerformanceModal}
        openFinancementsModal={openFinancementsModal}
      />
      <CoachingSection openFinancementsModal={openFinancementsModal} />
      <ContactSection />

      <Modal
        isOpen={isFinancementsModalOpen}
        onClose={() => setIsFinancementsModalOpen(false)}
      >
        <OptimizeModal type={modalType} />
      </Modal>

      <Modal
        isOpen={isIndicateursPerformanceModalOpen}
        onClose={() => setIsIndicateursPerformanceModalOpen(false)}
      >
        <IndicateursPerformanceModal type={modalType} formationId={modalFormationId} />
      </Modal>
    </div>
  );
};

export default HomePage;
